// 圆环canvas
export function circle_canvas(drawing_elem, percent, forecolor, bgcolor) {
    // @drawing_elem: 绘制对象
    // @percent：绘制圆环百分比, 范围[0, 100]
    // @forecolor: 绘制圆环的前景色，颜色代码
    // @bgcolor: 绘制圆环的背景色，颜色代码
    var context = drawing_elem.getContext('2d');
    var center_x = drawing_elem.width / 2;
    var center_y = drawing_elem.height / 2;
    var rad = (Math.PI * 2) / 100;
    var speed = 0;
    // drawing_elem.style.width = drawing_elem.parentNode.clientHeight + 'px';
    // drawing_elem.style.height = drawing_elem.parentNode.clientHeight + 'px';
    // drawing_elem.setAttribute('width', drawing_elem.parentNode.clientHeight * 2);
    // drawing_elem.setAttribute('height', drawing_elem.parentNode.clientHeight * 2);
    // 绘制背景圆圈
    function backgroundCircle() {
        context.save();
        context.beginPath();
        context.lineWidth = 8; //设置线宽
        var radius = center_x - context.lineWidth;
        context.lineCap = 'round';
        context.strokeStyle = bgcolor;
        context.arc(center_x, center_y, radius, 0, Math.PI * 2, false);
        context.stroke();
        context.closePath();
        context.restore();
    }

    //绘制运动圆环
    function foregroundCircle(n) {
        context.save();
        context.strokeStyle = forecolor;
        context.lineWidth = 8;
        context.lineCap = 'round';
        var radius = center_x - context.lineWidth;
        context.beginPath();
        context.arc(
            center_x,
            center_y,
            radius,
            -Math.PI / 2,
            -Math.PI / 2 + n * rad,
            false
        ); //用于绘制圆弧context.arc(x坐标，y坐标，半径，起始角度，终止角度，顺时针/逆时针)
        context.stroke();
        context.closePath();
        context.restore();
    }

    //执行动画
    (function drawFrame() {
        window.requestAnimationFrame(drawFrame);
        context.clearRect(0, 0, drawing_elem.width, drawing_elem.height);
        backgroundCircle();
        foregroundCircle(speed);
        if (speed >= percent) return;
        speed += 2;
    })();
}

// 计算百分比
export function component_percent(data, total) {
    // data 当前数值
    // total 总数值
    let percent = null;
    if (data > 0 && total > 0) {
        percent = ((data / total) * 100).toFixed(0);
    } else {
        percent = 0;
    }
    return percent;
}

/* 清除对象的为空字段 */
export function cleanObject(obj = {}) {
    let the_obj = JSON.parse(JSON.stringify(obj));
    for (let key in the_obj) {
        if (
            the_obj[key] === '' ||
            the_obj[key] === null ||
            the_obj[key] === undefined
        ) {
            delete the_obj[key];
        }
    }
    return the_obj;
}

/**
 * 防抖
 * @param {Function} func
 * @param {Number} wait
 */
export const bounce = (func, wait) => {
    let context, args;
    let timer = 0;

    return () => {
        context = this;
        args = arguments;
        timer && clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
};

/**
 * 字段替换
 * @param {Array} arr
 * @param {String} type
 */
export const fieldReplace = (arr = [], type = 'normal') => {
    let newArr = [];
    if (type === 'normal') {
        arr.forEach(item => {
            newArr.push({
                value: item.id,
                label: item.name
            });
        });
    } else {
        newArr = arr.child || [];
        // 递归 替换字段名
        function RecursionArr() {
            const that = this;
            // 递归
            this.recur = (_arr = []) => {
                let len = _arr.length;
                _arr.forEach((item, index) => {
                    if (item.hasOwnProperty('child')) {
                        _arr[index] = that.replaceField(item);
                        that.recur(_arr[index].children);
                    } else {
                        _arr[index] = that.replaceField(item);
                    }
                });
            };
            // 替换字段
            this.replaceField = (item = {}) => {
                const {
                    name: label,
                    id: value,
                    child: children
                } = item;
                return {
                    label,
                    value,
                    children
                };
            };
        }
        let loopArr = new RecursionArr();
        loopArr.recur(newArr);
    }
    return newArr;
};

/**
 * 根据最后一位的id匹配整棵树
 * @param {Array} arr
 * @param {Number} id
 */
export const matchTree = (arr = [], id) => { };

/**
 * 清洗返回的菜单数据
 * @param {Object} menu
 */
export function handleMenu(arr = []) {
    let menu = JSON.parse(JSON.stringify(arr));

    function handle(_arr = []) {
        _arr.forEach(item => {
            item.url = item.path;
            item.showChildren = Boolean(item.show_submenu);
            if (item.children && item.children.length > 0) {
                handle(item.children);
            } else {
                item.children = [];
            }
        });
    }
    handle(menu);
    return menu;
};

/**
 * 数组对象去重
 * @param {Object} arr
 */
export function unique(arr) {
    const res = new Map();
    return arr.filter((item) => !res.has(item.id) && res.set(item.id, 0));
};

/**
 * 数组对象结构调整
 * @param {Object} arr
 */

export function arrObjUnique(arr) {
    let arrUnique = [];
    let arrUniqueCopy = [];
    // 数组数据结构调整
    arr.forEach((item) => {
        if (item.title) {
            arrUniqueCopy.push(item.title.split("-")[0]);
        }
    });

    arrUnique = [...new Set(arrUniqueCopy)].join(",");;

    return arrUnique;
}


// WEBPACK FOOTER //
// ./src/utils/public.js